import {
  GetFrameAnnotationInfoDocument,
  GetFrameAnnotationInfoQuery,
  GetFrameAnnotationInfoQueryVariables,
  useApolloClient,
  useDeleteAnnotationMutation,
} from '@sketch/gql-types'
import { useFlag, removeFromPaginated } from '@sketch/modules-common'

interface useDeleteAnnotationCommentProps {
  identifier: string
  onCompleted?: () => void
}

const useDeleteAnnotation = ({
  identifier,
  onCompleted,
}: useDeleteAnnotationCommentProps) => {
  const includeHasUnreadComments = useFlag('pages-unread-annotations')
  const apollo = useApolloClient()

  const [mutate, { loading }] = useDeleteAnnotationMutation({
    variables: { identifier, includeHasUnreadComments },
    onError: 'show-toast',
    onCompleted: data => {
      const frameUUID = data?.deleteAnnotation.annotation.frameUuid
      const shareIdentifier = data?.deleteAnnotation.annotation.share.identifier
      if (frameUUID && shareIdentifier) {
        apollo.query<
          GetFrameAnnotationInfoQuery,
          GetFrameAnnotationInfoQueryVariables
        >({
          query: GetFrameAnnotationInfoDocument,
          variables: {
            frameUUID,
            shareIdentifier,
          },
        })
      }
      onCompleted && onCompleted()
    },
    update: (cache, { data }) => {
      if (data?.deleteAnnotation) {
        removeFromPaginated(
          cache,
          { __typename: 'Annotation', identifier },
          () => true
        )
      }
    },
  })
  return [mutate, { loading }] as const
}

export default useDeleteAnnotation
